import { ifAuthenticated } from '@/libs/acl/routeProtection'
import {
    CREDIT_CARD_USER,
    REGULLAR_BILLING
} from '@/service'
export default [
    {
        path: '/payment-card',
        name: 'payment-card',
        component: () => import('@/views/PaymentByCard'),
        meta: {
            services: [CREDIT_CARD_USER],
            serviceIdx: null,
            pageTitle: 'Paying by card',
            breadcrumb: [
                {
                    text: 'Paying by card',
                    active: true
                }
            ]
        },
        beforeEnter: ifAuthenticated
    },
    {
        path: '/woori-card-guide',
        name: 'woori-card-guide',
        meta: {
            services: [CREDIT_CARD_USER],
            serviceIdx: null,
            layout: 'full'
        },
        component: () => import('@/views/WooriCardGuide'),
        beforeEnter: ifAuthenticated
    },
    {
        path: '/card-assignment/payment/result',
        name: 'payment-card-result',
        meta: {
            services: [CREDIT_CARD_USER],
            serviceIdx: null,
            layout: 'full'
        },
        component: () => import('@/views/PaymentCardReceive'),
        props: route => ({ replyCd: route.query.replyCd, replyMsg: route.query.replyMsg }),
        beforeEnter: ifAuthenticated
    },
    {
        path: '/register-card',
        name: 'register-card',
        component: () => import('@/views/RegisterCard'),
        meta: {
            services: [REGULLAR_BILLING],
            serviceIdx: null,
            pageTitle: 'Register Card',
            breadcrumb: [
                {
                    text: 'Register Card',
                    active: true
                }
            ]
        },
        beforeEnter: ifAuthenticated
    },
    {
        path: '/register-card/receive',
        name: 'register-card-receive',
        meta: {
            services: [REGULLAR_BILLING, CREDIT_CARD_USER],
            serviceIdx: null,
            layout: 'full'
        },
        component: () => import('@/views/RegisterCardReceive'),
        props: route => ({ replyCd: route.query.replyCd, replyMsg: route.query.replyMsg }),
        beforeEnter: ifAuthenticated
    },
    {
        path: '/cancel-registered-card/receive',
        name: 'cancel-registered-card',
        meta: {
            services: [REGULLAR_BILLING, CREDIT_CARD_USER],
            serviceIdx: null,
            layout: 'full'
        },
        component: () => import('@/views/RegisterCardReceive'),
        props: route => ({ replyCd: route.query.replyCd, replyMsg: route.query.replyMsg }),
        beforeEnter: ifAuthenticated
    }
]
